export default __webpack_public_path__ + "static/media/Kiunalla4.f27b0a03.jpg";